var Student = "學生";
var jobRole = {
	"Job role": "職務",
	"Academic / Researcher": "學術/研究人員",
	"Advisor / Consultant": "顧問",
	"Business Executive": "企業高層",
	"Developer / Engineer": "開發人員/工程師",
	"Entrepreneur (Founder/Co-Founder)": "企業家 (創辦人/共同創辦人)",
	"IT Executive": "IT 主管",
	"IT Professional or Technical Manager": "IT 專業人員或技術經理",
	"Press / Media Analyst": "新聞/媒體分析師",
	"Sales / Marketing": "銷售/行銷",
	Student: Student,
	"Solution or Systems Architect": "解決方案或系統架構師",
	"System Administrator": "系統管理員",
	"Venture Capitalist": "創業投資家"
};

export { Student, jobRole as default };
